import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import PaymentMethod from '../../../../components/PaymentMethod/PaymentMethod';

export default function ChangePaymentMethod() {

  return (
    <div>
        <PaymentMethod redirect={false}/>
    </div>
  );
}
